/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import ContentLoader from "react-content-loader";
import { theme } from "@nordcloud/gnui";

const NUM_OF_ITEMS = 5;

function generateNumbers(limit: number) {
  return Array.from(Array(limit), (e, i) => i + 1);
}

export function ListLoader() {
  return (
    <div data-testid="loader">
      {generateNumbers(NUM_OF_ITEMS).map((item) => (
        <ListItem key={item} />
      ))}
    </div>
  );
}

function ListItem() {
  return (
    <ContentLoader
      speed={2}
      backgroundColor={theme.color.background.ui02}
      foregroundColor={theme.color.background.ui04}
      style={{ width: "100%", height: "80px" }}
    >
      <rect x="70" y="15" rx="5" ry="5" width="300" height="15" />
      <rect x="70" y="39" rx="5" ry="5" width="220" height="9" />
      <rect x="20" y="10" rx="0" ry="0" width="40" height="40" />
    </ContentLoader>
  );
}
